import { Icon, IconColor } from "@/components/shared/Icon"
import Tooltip from "@/components/shared/Tooltip"

export const TableActions = ({ onClick }: { onClick: () => void }) => {
   return (
      <Tooltip
         key="visual-tooltip"
         content="View"
      >
         <Icon
            name="visual"
            color={IconColor.HONOLULU_BLUE}
            size="16"
            onClick={onClick}
         />
      </Tooltip>
   )
}
